import React from 'react';

import { SearchDocumentType, SearchQuestionBody } from '../../../../../graphql/gen/types';
import { SearchAutocomplete } from './SearchAutocomplete';

type Props = {
  onSelect: (option: Fact) => void;
};

type Fact = { id: string; body: SearchQuestionBody };

export function FactSearch({ onSelect }: Props): React.ReactElement {
  return (
    <SearchAutocomplete
      onSelect={onSelect}
      mapSearchResult={(searchOption) =>
        searchOption.body.__typename === 'SearchQuestionBody'
          ? {
              id: searchOption.id,
              body: searchOption.body,
            }
          : null
      }
      getPlexId={(option) => option.body.plexId}
      getTitle={(option) => option.body.text || ''}
      getBody={(option) => option.body.acceptedAnswerBody || ''}
      filters={{ types: [SearchDocumentType.Question] }}
    />
  );
}
